
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import TenantSelectionModal from '../shared/TenantSelectionModal';
import PasswordInput from '../shared/PasswordInput';

function OwnerLogin() {
  const [email, setEmail] = useState('');
  const [ownerUsername, setOwnerUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loginStatus, setLoginStatus] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  // Multi-tenant selection state
  const [tenantSelection, setTenantSelection] = useState(null); // { tenants, owner }

  const baseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:5000';

  const loginowner = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setLoginStatus('');

    try {
      const response = await axios.post(`${baseUrl}/api/tenants/loginowner`, {
        email,
        username: ownerUsername,
        password,
      });

      if (response.data.success) {
        // Check if multiple tenants require selection
        if (response.data.requiresTenantSelection) {
          setTenantSelection({
            tenants: response.data.tenants,
            owner: response.data.owner
          });
          setIsLoading(false);
          return;
        }

        if (response.data.owner) {
          const owner = response.data.owner;
          localStorage.setItem('ownerId', owner.id);
          localStorage.setItem('ownerData', JSON.stringify(owner));
          navigate('/tenantadd', { state: owner });
        } else {
          setLoginStatus(response.data.message || 'Login failed');
        }
      } else {
        setLoginStatus(response.data.message || 'Login failed');
      }
    } catch (error) {
      console.error('Login error:', error);
      setLoginStatus('Server error. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleTenantSelect = (tenantId) => {
    // Owner selected a tenant - store and navigate to that tenant's dashboard
    const owner = tenantSelection.owner;
    localStorage.setItem('ownerId', owner.id);
    localStorage.setItem('ownerData', JSON.stringify({ ...owner, tenantid: tenantId }));
    setTenantSelection(null);
    navigate('/tenantadd', { state: { ...owner, tenantid: tenantId } });
  };

  return (
    <div className="owner-add-container">
      <div className="card">
        <h4 className="hdr hdr--primary hdr--lg">Login Here</h4>
        <div className="card-body">
          <form onSubmit={loginowner} className="form">
            <div className="form-group">
              <label htmlFor="email">Email:</label>
              <input
                className="textInput"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your Email"
                required
                disabled={isLoading}
              />
            </div>
            <div className="form-group">
              <label htmlFor="username">Username:</label>
              <input
                className="textInput"
                type="text"
                value={ownerUsername}
                onChange={(e) => setOwnerUsername(e.target.value)}
                placeholder="Enter your Username"
                required
                disabled={isLoading}
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Password:</label>
              <PasswordInput
                className="textInput"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your Password"
                required
                disabled={isLoading}
              />
            </div>
            <button type="submit" className="btn btn-primary" disabled={isLoading}>
              {isLoading ? 'Logging in...' : 'Login'}
            </button>
            {loginStatus && <p style={{ color: 'red' }}>{loginStatus}</p>}
          </form>
        </div>
      </div>

      {tenantSelection && (
        <TenantSelectionModal
          tenants={tenantSelection.tenants}
          onSelect={handleTenantSelect}
          onCancel={() => setTenantSelection(null)}
          isLoading={false}
        />
      )}
    </div>
  );
}

export default OwnerLogin;
